import { render, staticRenderFns } from "./KBGenesList.vue?vue&type=template&id=2d31fd46&scoped=true&"
import script from "./KBGenesList.vue?vue&type=script&lang=js&"
export * from "./KBGenesList.vue?vue&type=script&lang=js&"
import style0 from "./KBGenesList.vue?vue&type=style&index=0&id=2d31fd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31fd46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VChip,VCol,VCombobox,VIcon,VRow,VSelect,VSimpleTable})
